import { StandardDialog } from "@roc/ui";
import { observer } from "mobx-react";
import { useEffect } from "react";
import { ReplyInTaskStore } from "../../stores/replyInTaskStore";
import { ReplyInTask } from "./replyInTask";
import { Message } from "@twilio/conversations";
import { useGeneralTasksStore } from "@roc/feature-general-tasks";

interface IReplyInTaskDialog {
  replyInTaskStore: ReplyInTaskStore;
  sendReplyInTaskMessage: (message: String, taskId: number, replyToMessage: Message) => void;
}

export const ReplyInTaskDialog: React.FC<IReplyInTaskDialog> = observer(({ replyInTaskStore, sendReplyInTaskMessage }) => {
  const { generalTasksStore } = useGeneralTasksStore();

  useEffect(() => {
    replyInTaskStore.fetchLoanTaskOptions();
  }, []);


  const handleClose = () => {
    replyInTaskStore.reset();
    generalTasksStore.reset();
  }

  return (
    <StandardDialog
      title={`Loan #${replyInTaskStore.loanId}`}
      open={replyInTaskStore.isModalOpen}
      handleClose={handleClose}
      maxWidth={'md'}
      removeContentBox={true}
      dialogContent={
        <ReplyInTask replyInTaskStore={replyInTaskStore} sendReplyInTaskMessage={sendReplyInTaskMessage} />
      }
    />
  );
});